/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as V2RouteImport } from './routes/v2'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PostsRouteImport } from './routes/posts'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as PitchRouteImport } from './routes/pitch'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as HomeV5RouteImport } from './routes/home-v5'
import { Route as HomeV3RouteImport } from './routes/home-v3'
import { Route as HomeV2RouteImport } from './routes/home-v2'
import { Route as DcucRouteImport } from './routes/dcuc'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as StatesIndexRouteImport } from './routes/states.index'
import { Route as SolutionsIndexRouteImport } from './routes/solutions.index'
import { Route as ScamLibraryIndexRouteImport } from './routes/scam-library.index'
import { Route as BasicsIndexRouteImport } from './routes/basics.index'
import { Route as ArticlesIndexRouteImport } from './routes/articles.index'
import { Route as ToolsScamCheckerRouteImport } from './routes/tools.scam-checker'
import { Route as ToolsPasswordCheckRouteImport } from './routes/tools.password-check'
import { Route as ToolsCharityCheckerRouteImport } from './routes/tools.charity-checker'
import { Route as StatesSlugRouteImport } from './routes/states.$slug'
import { Route as SolutionsWealthAdvisorsRouteImport } from './routes/solutions.wealth-advisors'
import { Route as SolutionsStateAgenciesRouteImport } from './routes/solutions.state-agencies'
import { Route as SolutionsFinancialInstitutionsRouteImport } from './routes/solutions.financial-institutions'
import { Route as SolutionsDefenseCreditUnionsRouteImport } from './routes/solutions.defense-credit-unions'
import { Route as SolutionsCommunityPartnersRouteImport } from './routes/solutions.community-partners'
import { Route as ScamLibrarySlugRouteImport } from './routes/scam-library.$slug'
import { Route as PrivacyOptOutRouteImport } from './routes/privacy.opt-out'
import { Route as BasicsBasicsSlugRouteImport } from './routes/basics.$basicsSlug'
import { Route as ArticlesSlugRouteImport } from './routes/articles.$slug'
import { Route as StatesSlugIndexRouteImport } from './routes/states.$slug.index'
import { Route as BasicsBasicsSlugIndexRouteImport } from './routes/basics.$basicsSlug.index'
import { Route as BasicsBasicsSlugStartRouteImport } from './routes/basics.$basicsSlug.start'
import { Route as StatesSlugScamsScamSlugRouteImport } from './routes/states.$slug.scams.$scamSlug'

const V2Route = V2RouteImport.update({
  id: '/v2',
  path: '/v2',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsRoute = PostsRouteImport.update({
  id: '/posts',
  path: '/posts',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const PitchRoute = PitchRouteImport.update({
  id: '/pitch',
  path: '/pitch',
  getParentRoute: () => rootRouteImport,
} as any)
const HowItWorksRoute = HowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeV5Route = HomeV5RouteImport.update({
  id: '/home-v5',
  path: '/home-v5',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeV3Route = HomeV3RouteImport.update({
  id: '/home-v3',
  path: '/home-v3',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeV2Route = HomeV2RouteImport.update({
  id: '/home-v2',
  path: '/home-v2',
  getParentRoute: () => rootRouteImport,
} as any)
const DcucRoute = DcucRouteImport.update({
  id: '/dcuc',
  path: '/dcuc',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsIndexRoute = ToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => rootRouteImport,
} as any)
const StatesIndexRoute = StatesIndexRouteImport.update({
  id: '/states/',
  path: '/states/',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsIndexRoute = SolutionsIndexRouteImport.update({
  id: '/solutions/',
  path: '/solutions/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScamLibraryIndexRoute = ScamLibraryIndexRouteImport.update({
  id: '/scam-library/',
  path: '/scam-library/',
  getParentRoute: () => rootRouteImport,
} as any)
const BasicsIndexRoute = BasicsIndexRouteImport.update({
  id: '/basics/',
  path: '/basics/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsScamCheckerRoute = ToolsScamCheckerRouteImport.update({
  id: '/tools/scam-checker',
  path: '/tools/scam-checker',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsPasswordCheckRoute = ToolsPasswordCheckRouteImport.update({
  id: '/tools/password-check',
  path: '/tools/password-check',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsCharityCheckerRoute = ToolsCharityCheckerRouteImport.update({
  id: '/tools/charity-checker',
  path: '/tools/charity-checker',
  getParentRoute: () => rootRouteImport,
} as any)
const StatesSlugRoute = StatesSlugRouteImport.update({
  id: '/states/$slug',
  path: '/states/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsWealthAdvisorsRoute = SolutionsWealthAdvisorsRouteImport.update({
  id: '/solutions/wealth-advisors',
  path: '/solutions/wealth-advisors',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsStateAgenciesRoute = SolutionsStateAgenciesRouteImport.update({
  id: '/solutions/state-agencies',
  path: '/solutions/state-agencies',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsFinancialInstitutionsRoute =
  SolutionsFinancialInstitutionsRouteImport.update({
    id: '/solutions/financial-institutions',
    path: '/solutions/financial-institutions',
    getParentRoute: () => rootRouteImport,
  } as any)
const SolutionsDefenseCreditUnionsRoute =
  SolutionsDefenseCreditUnionsRouteImport.update({
    id: '/solutions/defense-credit-unions',
    path: '/solutions/defense-credit-unions',
    getParentRoute: () => rootRouteImport,
  } as any)
const SolutionsCommunityPartnersRoute =
  SolutionsCommunityPartnersRouteImport.update({
    id: '/solutions/community-partners',
    path: '/solutions/community-partners',
    getParentRoute: () => rootRouteImport,
  } as any)
const ScamLibrarySlugRoute = ScamLibrarySlugRouteImport.update({
  id: '/scam-library/$slug',
  path: '/scam-library/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyOptOutRoute = PrivacyOptOutRouteImport.update({
  id: '/opt-out',
  path: '/opt-out',
  getParentRoute: () => PrivacyRoute,
} as any)
const BasicsBasicsSlugRoute = BasicsBasicsSlugRouteImport.update({
  id: '/basics/$basicsSlug',
  path: '/basics/$basicsSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
  id: '/articles/$slug',
  path: '/articles/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const StatesSlugIndexRoute = StatesSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StatesSlugRoute,
} as any)
const BasicsBasicsSlugIndexRoute = BasicsBasicsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BasicsBasicsSlugRoute,
} as any)
const BasicsBasicsSlugStartRoute = BasicsBasicsSlugStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => BasicsBasicsSlugRoute,
} as any)
const StatesSlugScamsScamSlugRoute = StatesSlugScamsScamSlugRouteImport.update({
  id: '/scams/$scamSlug',
  path: '/scams/$scamSlug',
  getParentRoute: () => StatesSlugRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/dcuc': typeof DcucRoute
  '/home-v2': typeof HomeV2Route
  '/home-v3': typeof HomeV3Route
  '/home-v5': typeof HomeV5Route
  '/how-it-works': typeof HowItWorksRoute
  '/pitch': typeof PitchRoute
  '/platform': typeof PlatformRoute
  '/posts': typeof PostsRoute
  '/privacy': typeof PrivacyRouteWithChildren
  '/terms': typeof TermsRoute
  '/v2': typeof V2Route
  '/articles/$slug': typeof ArticlesSlugRoute
  '/basics/$basicsSlug': typeof BasicsBasicsSlugRouteWithChildren
  '/privacy/opt-out': typeof PrivacyOptOutRoute
  '/scam-library/$slug': typeof ScamLibrarySlugRoute
  '/solutions/community-partners': typeof SolutionsCommunityPartnersRoute
  '/solutions/defense-credit-unions': typeof SolutionsDefenseCreditUnionsRoute
  '/solutions/financial-institutions': typeof SolutionsFinancialInstitutionsRoute
  '/solutions/state-agencies': typeof SolutionsStateAgenciesRoute
  '/solutions/wealth-advisors': typeof SolutionsWealthAdvisorsRoute
  '/states/$slug': typeof StatesSlugRouteWithChildren
  '/tools/charity-checker': typeof ToolsCharityCheckerRoute
  '/tools/password-check': typeof ToolsPasswordCheckRoute
  '/tools/scam-checker': typeof ToolsScamCheckerRoute
  '/articles/': typeof ArticlesIndexRoute
  '/basics/': typeof BasicsIndexRoute
  '/scam-library/': typeof ScamLibraryIndexRoute
  '/solutions/': typeof SolutionsIndexRoute
  '/states/': typeof StatesIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/basics/$basicsSlug/start': typeof BasicsBasicsSlugStartRoute
  '/basics/$basicsSlug/': typeof BasicsBasicsSlugIndexRoute
  '/states/$slug/': typeof StatesSlugIndexRoute
  '/states/$slug/scams/$scamSlug': typeof StatesSlugScamsScamSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/dcuc': typeof DcucRoute
  '/home-v2': typeof HomeV2Route
  '/home-v3': typeof HomeV3Route
  '/home-v5': typeof HomeV5Route
  '/how-it-works': typeof HowItWorksRoute
  '/pitch': typeof PitchRoute
  '/platform': typeof PlatformRoute
  '/posts': typeof PostsRoute
  '/privacy': typeof PrivacyRouteWithChildren
  '/terms': typeof TermsRoute
  '/v2': typeof V2Route
  '/articles/$slug': typeof ArticlesSlugRoute
  '/privacy/opt-out': typeof PrivacyOptOutRoute
  '/scam-library/$slug': typeof ScamLibrarySlugRoute
  '/solutions/community-partners': typeof SolutionsCommunityPartnersRoute
  '/solutions/defense-credit-unions': typeof SolutionsDefenseCreditUnionsRoute
  '/solutions/financial-institutions': typeof SolutionsFinancialInstitutionsRoute
  '/solutions/state-agencies': typeof SolutionsStateAgenciesRoute
  '/solutions/wealth-advisors': typeof SolutionsWealthAdvisorsRoute
  '/tools/charity-checker': typeof ToolsCharityCheckerRoute
  '/tools/password-check': typeof ToolsPasswordCheckRoute
  '/tools/scam-checker': typeof ToolsScamCheckerRoute
  '/articles': typeof ArticlesIndexRoute
  '/basics': typeof BasicsIndexRoute
  '/scam-library': typeof ScamLibraryIndexRoute
  '/solutions': typeof SolutionsIndexRoute
  '/states': typeof StatesIndexRoute
  '/tools': typeof ToolsIndexRoute
  '/basics/$basicsSlug/start': typeof BasicsBasicsSlugStartRoute
  '/basics/$basicsSlug': typeof BasicsBasicsSlugIndexRoute
  '/states/$slug': typeof StatesSlugIndexRoute
  '/states/$slug/scams/$scamSlug': typeof StatesSlugScamsScamSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/dcuc': typeof DcucRoute
  '/home-v2': typeof HomeV2Route
  '/home-v3': typeof HomeV3Route
  '/home-v5': typeof HomeV5Route
  '/how-it-works': typeof HowItWorksRoute
  '/pitch': typeof PitchRoute
  '/platform': typeof PlatformRoute
  '/posts': typeof PostsRoute
  '/privacy': typeof PrivacyRouteWithChildren
  '/terms': typeof TermsRoute
  '/v2': typeof V2Route
  '/articles/$slug': typeof ArticlesSlugRoute
  '/basics/$basicsSlug': typeof BasicsBasicsSlugRouteWithChildren
  '/privacy/opt-out': typeof PrivacyOptOutRoute
  '/scam-library/$slug': typeof ScamLibrarySlugRoute
  '/solutions/community-partners': typeof SolutionsCommunityPartnersRoute
  '/solutions/defense-credit-unions': typeof SolutionsDefenseCreditUnionsRoute
  '/solutions/financial-institutions': typeof SolutionsFinancialInstitutionsRoute
  '/solutions/state-agencies': typeof SolutionsStateAgenciesRoute
  '/solutions/wealth-advisors': typeof SolutionsWealthAdvisorsRoute
  '/states/$slug': typeof StatesSlugRouteWithChildren
  '/tools/charity-checker': typeof ToolsCharityCheckerRoute
  '/tools/password-check': typeof ToolsPasswordCheckRoute
  '/tools/scam-checker': typeof ToolsScamCheckerRoute
  '/articles/': typeof ArticlesIndexRoute
  '/basics/': typeof BasicsIndexRoute
  '/scam-library/': typeof ScamLibraryIndexRoute
  '/solutions/': typeof SolutionsIndexRoute
  '/states/': typeof StatesIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/basics/$basicsSlug/start': typeof BasicsBasicsSlugStartRoute
  '/basics/$basicsSlug/': typeof BasicsBasicsSlugIndexRoute
  '/states/$slug/': typeof StatesSlugIndexRoute
  '/states/$slug/scams/$scamSlug': typeof StatesSlugScamsScamSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/dcuc'
    | '/home-v2'
    | '/home-v3'
    | '/home-v5'
    | '/how-it-works'
    | '/pitch'
    | '/platform'
    | '/posts'
    | '/privacy'
    | '/terms'
    | '/v2'
    | '/articles/$slug'
    | '/basics/$basicsSlug'
    | '/privacy/opt-out'
    | '/scam-library/$slug'
    | '/solutions/community-partners'
    | '/solutions/defense-credit-unions'
    | '/solutions/financial-institutions'
    | '/solutions/state-agencies'
    | '/solutions/wealth-advisors'
    | '/states/$slug'
    | '/tools/charity-checker'
    | '/tools/password-check'
    | '/tools/scam-checker'
    | '/articles/'
    | '/basics/'
    | '/scam-library/'
    | '/solutions/'
    | '/states/'
    | '/tools/'
    | '/basics/$basicsSlug/start'
    | '/basics/$basicsSlug/'
    | '/states/$slug/'
    | '/states/$slug/scams/$scamSlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/dcuc'
    | '/home-v2'
    | '/home-v3'
    | '/home-v5'
    | '/how-it-works'
    | '/pitch'
    | '/platform'
    | '/posts'
    | '/privacy'
    | '/terms'
    | '/v2'
    | '/articles/$slug'
    | '/privacy/opt-out'
    | '/scam-library/$slug'
    | '/solutions/community-partners'
    | '/solutions/defense-credit-unions'
    | '/solutions/financial-institutions'
    | '/solutions/state-agencies'
    | '/solutions/wealth-advisors'
    | '/tools/charity-checker'
    | '/tools/password-check'
    | '/tools/scam-checker'
    | '/articles'
    | '/basics'
    | '/scam-library'
    | '/solutions'
    | '/states'
    | '/tools'
    | '/basics/$basicsSlug/start'
    | '/basics/$basicsSlug'
    | '/states/$slug'
    | '/states/$slug/scams/$scamSlug'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/contact'
    | '/dcuc'
    | '/home-v2'
    | '/home-v3'
    | '/home-v5'
    | '/how-it-works'
    | '/pitch'
    | '/platform'
    | '/posts'
    | '/privacy'
    | '/terms'
    | '/v2'
    | '/articles/$slug'
    | '/basics/$basicsSlug'
    | '/privacy/opt-out'
    | '/scam-library/$slug'
    | '/solutions/community-partners'
    | '/solutions/defense-credit-unions'
    | '/solutions/financial-institutions'
    | '/solutions/state-agencies'
    | '/solutions/wealth-advisors'
    | '/states/$slug'
    | '/tools/charity-checker'
    | '/tools/password-check'
    | '/tools/scam-checker'
    | '/articles/'
    | '/basics/'
    | '/scam-library/'
    | '/solutions/'
    | '/states/'
    | '/tools/'
    | '/basics/$basicsSlug/start'
    | '/basics/$basicsSlug/'
    | '/states/$slug/'
    | '/states/$slug/scams/$scamSlug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  DcucRoute: typeof DcucRoute
  HomeV2Route: typeof HomeV2Route
  HomeV3Route: typeof HomeV3Route
  HomeV5Route: typeof HomeV5Route
  HowItWorksRoute: typeof HowItWorksRoute
  PitchRoute: typeof PitchRoute
  PlatformRoute: typeof PlatformRoute
  PostsRoute: typeof PostsRoute
  PrivacyRoute: typeof PrivacyRouteWithChildren
  TermsRoute: typeof TermsRoute
  V2Route: typeof V2Route
  ArticlesSlugRoute: typeof ArticlesSlugRoute
  BasicsBasicsSlugRoute: typeof BasicsBasicsSlugRouteWithChildren
  ScamLibrarySlugRoute: typeof ScamLibrarySlugRoute
  SolutionsCommunityPartnersRoute: typeof SolutionsCommunityPartnersRoute
  SolutionsDefenseCreditUnionsRoute: typeof SolutionsDefenseCreditUnionsRoute
  SolutionsFinancialInstitutionsRoute: typeof SolutionsFinancialInstitutionsRoute
  SolutionsStateAgenciesRoute: typeof SolutionsStateAgenciesRoute
  SolutionsWealthAdvisorsRoute: typeof SolutionsWealthAdvisorsRoute
  StatesSlugRoute: typeof StatesSlugRouteWithChildren
  ToolsCharityCheckerRoute: typeof ToolsCharityCheckerRoute
  ToolsPasswordCheckRoute: typeof ToolsPasswordCheckRoute
  ToolsScamCheckerRoute: typeof ToolsScamCheckerRoute
  ArticlesIndexRoute: typeof ArticlesIndexRoute
  BasicsIndexRoute: typeof BasicsIndexRoute
  ScamLibraryIndexRoute: typeof ScamLibraryIndexRoute
  SolutionsIndexRoute: typeof SolutionsIndexRoute
  StatesIndexRoute: typeof StatesIndexRoute
  ToolsIndexRoute: typeof ToolsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/v2': {
      id: '/v2'
      path: '/v2'
      fullPath: '/v2'
      preLoaderRoute: typeof V2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts': {
      id: '/posts'
      path: '/posts'
      fullPath: '/posts'
      preLoaderRoute: typeof PostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pitch': {
      id: '/pitch'
      path: '/pitch'
      fullPath: '/pitch'
      preLoaderRoute: typeof PitchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-it-works': {
      id: '/how-it-works'
      path: '/how-it-works'
      fullPath: '/how-it-works'
      preLoaderRoute: typeof HowItWorksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home-v5': {
      id: '/home-v5'
      path: '/home-v5'
      fullPath: '/home-v5'
      preLoaderRoute: typeof HomeV5RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home-v3': {
      id: '/home-v3'
      path: '/home-v3'
      fullPath: '/home-v3'
      preLoaderRoute: typeof HomeV3RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home-v2': {
      id: '/home-v2'
      path: '/home-v2'
      fullPath: '/home-v2'
      preLoaderRoute: typeof HomeV2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dcuc': {
      id: '/dcuc'
      path: '/dcuc'
      fullPath: '/dcuc'
      preLoaderRoute: typeof DcucRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/': {
      id: '/tools/'
      path: '/tools'
      fullPath: '/tools/'
      preLoaderRoute: typeof ToolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/states/': {
      id: '/states/'
      path: '/states'
      fullPath: '/states/'
      preLoaderRoute: typeof StatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/': {
      id: '/solutions/'
      path: '/solutions'
      fullPath: '/solutions/'
      preLoaderRoute: typeof SolutionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scam-library/': {
      id: '/scam-library/'
      path: '/scam-library'
      fullPath: '/scam-library/'
      preLoaderRoute: typeof ScamLibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/basics/': {
      id: '/basics/'
      path: '/basics'
      fullPath: '/basics/'
      preLoaderRoute: typeof BasicsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/': {
      id: '/articles/'
      path: '/articles'
      fullPath: '/articles/'
      preLoaderRoute: typeof ArticlesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/scam-checker': {
      id: '/tools/scam-checker'
      path: '/tools/scam-checker'
      fullPath: '/tools/scam-checker'
      preLoaderRoute: typeof ToolsScamCheckerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/password-check': {
      id: '/tools/password-check'
      path: '/tools/password-check'
      fullPath: '/tools/password-check'
      preLoaderRoute: typeof ToolsPasswordCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/charity-checker': {
      id: '/tools/charity-checker'
      path: '/tools/charity-checker'
      fullPath: '/tools/charity-checker'
      preLoaderRoute: typeof ToolsCharityCheckerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/states/$slug': {
      id: '/states/$slug'
      path: '/states/$slug'
      fullPath: '/states/$slug'
      preLoaderRoute: typeof StatesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/wealth-advisors': {
      id: '/solutions/wealth-advisors'
      path: '/solutions/wealth-advisors'
      fullPath: '/solutions/wealth-advisors'
      preLoaderRoute: typeof SolutionsWealthAdvisorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/state-agencies': {
      id: '/solutions/state-agencies'
      path: '/solutions/state-agencies'
      fullPath: '/solutions/state-agencies'
      preLoaderRoute: typeof SolutionsStateAgenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/financial-institutions': {
      id: '/solutions/financial-institutions'
      path: '/solutions/financial-institutions'
      fullPath: '/solutions/financial-institutions'
      preLoaderRoute: typeof SolutionsFinancialInstitutionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/defense-credit-unions': {
      id: '/solutions/defense-credit-unions'
      path: '/solutions/defense-credit-unions'
      fullPath: '/solutions/defense-credit-unions'
      preLoaderRoute: typeof SolutionsDefenseCreditUnionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/community-partners': {
      id: '/solutions/community-partners'
      path: '/solutions/community-partners'
      fullPath: '/solutions/community-partners'
      preLoaderRoute: typeof SolutionsCommunityPartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scam-library/$slug': {
      id: '/scam-library/$slug'
      path: '/scam-library/$slug'
      fullPath: '/scam-library/$slug'
      preLoaderRoute: typeof ScamLibrarySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy/opt-out': {
      id: '/privacy/opt-out'
      path: '/opt-out'
      fullPath: '/privacy/opt-out'
      preLoaderRoute: typeof PrivacyOptOutRouteImport
      parentRoute: typeof PrivacyRoute
    }
    '/basics/$basicsSlug': {
      id: '/basics/$basicsSlug'
      path: '/basics/$basicsSlug'
      fullPath: '/basics/$basicsSlug'
      preLoaderRoute: typeof BasicsBasicsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$slug': {
      id: '/articles/$slug'
      path: '/articles/$slug'
      fullPath: '/articles/$slug'
      preLoaderRoute: typeof ArticlesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/states/$slug/': {
      id: '/states/$slug/'
      path: '/'
      fullPath: '/states/$slug/'
      preLoaderRoute: typeof StatesSlugIndexRouteImport
      parentRoute: typeof StatesSlugRoute
    }
    '/basics/$basicsSlug/': {
      id: '/basics/$basicsSlug/'
      path: '/'
      fullPath: '/basics/$basicsSlug/'
      preLoaderRoute: typeof BasicsBasicsSlugIndexRouteImport
      parentRoute: typeof BasicsBasicsSlugRoute
    }
    '/basics/$basicsSlug/start': {
      id: '/basics/$basicsSlug/start'
      path: '/start'
      fullPath: '/basics/$basicsSlug/start'
      preLoaderRoute: typeof BasicsBasicsSlugStartRouteImport
      parentRoute: typeof BasicsBasicsSlugRoute
    }
    '/states/$slug/scams/$scamSlug': {
      id: '/states/$slug/scams/$scamSlug'
      path: '/scams/$scamSlug'
      fullPath: '/states/$slug/scams/$scamSlug'
      preLoaderRoute: typeof StatesSlugScamsScamSlugRouteImport
      parentRoute: typeof StatesSlugRoute
    }
  }
}

interface PrivacyRouteChildren {
  PrivacyOptOutRoute: typeof PrivacyOptOutRoute
}

const PrivacyRouteChildren: PrivacyRouteChildren = {
  PrivacyOptOutRoute: PrivacyOptOutRoute,
}

const PrivacyRouteWithChildren =
  PrivacyRoute._addFileChildren(PrivacyRouteChildren)

interface BasicsBasicsSlugRouteChildren {
  BasicsBasicsSlugStartRoute: typeof BasicsBasicsSlugStartRoute
  BasicsBasicsSlugIndexRoute: typeof BasicsBasicsSlugIndexRoute
}

const BasicsBasicsSlugRouteChildren: BasicsBasicsSlugRouteChildren = {
  BasicsBasicsSlugStartRoute: BasicsBasicsSlugStartRoute,
  BasicsBasicsSlugIndexRoute: BasicsBasicsSlugIndexRoute,
}

const BasicsBasicsSlugRouteWithChildren =
  BasicsBasicsSlugRoute._addFileChildren(BasicsBasicsSlugRouteChildren)

interface StatesSlugRouteChildren {
  StatesSlugIndexRoute: typeof StatesSlugIndexRoute
  StatesSlugScamsScamSlugRoute: typeof StatesSlugScamsScamSlugRoute
}

const StatesSlugRouteChildren: StatesSlugRouteChildren = {
  StatesSlugIndexRoute: StatesSlugIndexRoute,
  StatesSlugScamsScamSlugRoute: StatesSlugScamsScamSlugRoute,
}

const StatesSlugRouteWithChildren = StatesSlugRoute._addFileChildren(
  StatesSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  DcucRoute: DcucRoute,
  HomeV2Route: HomeV2Route,
  HomeV3Route: HomeV3Route,
  HomeV5Route: HomeV5Route,
  HowItWorksRoute: HowItWorksRoute,
  PitchRoute: PitchRoute,
  PlatformRoute: PlatformRoute,
  PostsRoute: PostsRoute,
  PrivacyRoute: PrivacyRouteWithChildren,
  TermsRoute: TermsRoute,
  V2Route: V2Route,
  ArticlesSlugRoute: ArticlesSlugRoute,
  BasicsBasicsSlugRoute: BasicsBasicsSlugRouteWithChildren,
  ScamLibrarySlugRoute: ScamLibrarySlugRoute,
  SolutionsCommunityPartnersRoute: SolutionsCommunityPartnersRoute,
  SolutionsDefenseCreditUnionsRoute: SolutionsDefenseCreditUnionsRoute,
  SolutionsFinancialInstitutionsRoute: SolutionsFinancialInstitutionsRoute,
  SolutionsStateAgenciesRoute: SolutionsStateAgenciesRoute,
  SolutionsWealthAdvisorsRoute: SolutionsWealthAdvisorsRoute,
  StatesSlugRoute: StatesSlugRouteWithChildren,
  ToolsCharityCheckerRoute: ToolsCharityCheckerRoute,
  ToolsPasswordCheckRoute: ToolsPasswordCheckRoute,
  ToolsScamCheckerRoute: ToolsScamCheckerRoute,
  ArticlesIndexRoute: ArticlesIndexRoute,
  BasicsIndexRoute: BasicsIndexRoute,
  ScamLibraryIndexRoute: ScamLibraryIndexRoute,
  SolutionsIndexRoute: SolutionsIndexRoute,
  StatesIndexRoute: StatesIndexRoute,
  ToolsIndexRoute: ToolsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
